import LocationAPI from '@/apis/business/locationAPI'
import CrudBase from '@/stores/crudBase.js'
import { MSConstant } from '@/commons/wildcards'

const apiURL = LocationAPI.getAPIUrl()

const crudBase = new CrudBase('location', LocationAPI)
export default {
  namespaced: true,
  state: {
    ...crudBase.state,
  },
  mutations: {
    ...crudBase.mutations,
  },
  getters: {
    ...crudBase.getters,
  },
  actions: {
    ...crudBase.actions,
    /**
     * @description Lấy thông tin địa bàn
     * @author VHSON
     * @createdDate 20/09/2022
     * @param {*} context
     * @returns
     */
    async getLocations ({ commit }, param) {
      let url = `${apiURL}/location?kind=${param.kind}&sort=sortOrder:desc,locationName:asc`
      switch (param.kind) {
        case MSConstant.LocationKind.Ward:
          url += `&parentLocationName=${param.parentLocationName}&grandLocationName=${param.grandLocationName}`
          break
        default:
          url += `&parentLocationName=${param.parentLocationName}`
          break
      }
      if (param.filter) {
        url += `&filter=${param.filter}`
      }
      const result = await LocationAPI.getAsync({
        url: url,
      })
      return result
    },
  },
}
